import React from 'react'
import { css } from '@emotion/core'

import Container from 'components/layouts/atoms/Container'
import Typography from 'components/common/atoms/Typography'
import SectionContainer from 'components/layouts/atoms/SectionContainer'
import Timeline from 'components/common/organisms/Timeline'

import KoinworksStepData from './KoinworksStepData.json'

const koinworksStepStyle = css`
  .koinworks-step {
    &__steps {
      padding-top: 16px;
    }
    &__title {
      line-height: 1.5;
    }
    @media screen and (min-width: 768px) {
      &__title {
        text-align: center;
      }
      &__steps {
        padding-top: 24px;
      }
    }
  }
`

const KoinworksStep = () => (
  <div className="koinworks-step" css={koinworksStepStyle}>
    <SectionContainer withPaddingBottom>
      <Container>
        <Typography variant="title" level="2" tagName="h2" fontWeight="bold" className="koinworks-step__title">
          Proses Pengajuan Pinjaman
        </Typography>
        <div className="koinworks-step__steps">
          <Timeline steps={KoinworksStepData} />
        </div>
      </Container>
    </SectionContainer>
  </div>
)

export default KoinworksStep
